import { line } from 'd3-shape';

import { ShapeGenerator, ShapeGeneratorFactory, XYSeriesPoint } from '../XYChart';

export const lineShapeGeneratorFactory: ShapeGeneratorFactory<XYSeriesPoint<unknown>> = ({ xScale, yScale }) => {
  const generator = line<XYSeriesPoint<unknown>>();
  generator.defined((point) => {
    const x = point.data[0];
    // No need to check the first coordinate ("y0"), since the line generator doesn't use it
    const [, y] = point;

    return Number.isFinite(y) && Number.isFinite(x.valueOf());
  });

  /* eslint-disable @typescript-eslint/no-non-null-assertion -- getters should not be invoked for values that would return undefined */
  // TODO double check assertions
  generator.x(({ data }) => xScale(data[0])!);
  generator.y(([, y]) => yScale(y!)!);
  /* eslint-enable @typescript-eslint/no-non-null-assertion -- re-enable */

  // This type assertion ensures that the generator always returns a string. The generator is typed to
  // return `string | null` because it can return null if a rendering context is set, but since we
  // don't do that, it should always return a string.
  return generator as ShapeGenerator<XYSeriesPoint<unknown>>;
};
